import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Option = props => {
  const handleClick = () => {
    props.handleClick(props.index);
  };

  return props.radioSort ? (
    <label
      className={classNames('radio-option', { active: props.active })}
      onClick={handleClick}
    >
      <input
        id={props.text}
        type="radio"
        name="values"
        value={props.text}
        defaultChecked={props.active}
      ></input>
      <div className="styled-input-border-line">
        <div className="styled-input-dot"></div>
      </div>
      <span>{props.text}</span>
    </label>
  ) : (
    <div
      className={classNames('option', { active: props.active })}
      onClick={handleClick}
    >
      {props.text}
    </div>
  );
};

Option.propTypes = {
  radioSort: PropTypes.bool,
  active: PropTypes.bool,
  text: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ]),
  handleClick: PropTypes.func.isRequired,
  index: PropTypes.number,
};

export default Option;
